import { trackPromise } from "react-promise-tracker";
import CommonUtil from "utils/CommonUtil";

/**
 * 게시판(FAQ) RestRepository
 */
export default class FaqRestRepository {
  private path;

  public constructor(notiTpCd: string) {
    this.path = `/portal/support/faq/Faq/${notiTpCd}/`;
  }

  /**
   * 목록 조회
   *
   * @param search
   */
  public async getList(search: any): Promise<any> {
    return await trackPromise(
      CommonUtil.axios()
        .get(this.path + "list", { data: search })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
        })
    );
  }

  /**
   * 최근 목록 조회
   *
   * @param notiTpCd
   * @param recordCount
   */
  public async getLatelyList(notiTpCd: string, recordCount: number): Promise<any> {
    return await trackPromise(
      CommonUtil.axios()
        .get(this.path + "latelyList", { params: { recordCount: recordCount } })
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
        })
    );
  }
  /**
   * 조회
   *
   * @param search
   */
  public async get(notiNo: string): Promise<any> {
    return await trackPromise(
      CommonUtil.axios()
        .get(this.path + notiNo)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
        })
    );
  }
  /**
   * 조회수 업데이트
   *
   * @param notiNo
   */
  public async updateCnt(notiNo: string): Promise<boolean> {
    return await trackPromise(
      CommonUtil.axios()
        .post(this.path + "updateCnt", notiNo)
        .then((response) => {
          return true;
        })
        .catch((error) => {
          CommonUtil.showAxiosError(error);
          return false;
        })
    );
  }
}
